import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION,
  GET_INTEGRATION_BY_CATEGORY,
  GET_INTEGRATION_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegration",
    method: "post",
    url: CRUD_INTEGRATION,
    stateKey: "message",
  },
  {
    name: "getIntegrationByCategory",
    method: "get",
    url: GET_INTEGRATION_BY_CATEGORY,
    stateKey: "data",
  },
  {
    name: "getIntegrationDetails",
    method: "get",
    url: GET_INTEGRATION_DETAILS,
    stateKey: "details",
  },
  {
    name: "updateIntegration",
    method: "put",
    url: CRUD_INTEGRATION,
    stateKey: "message",
  },
  {
    name: "deleteIntegration",
    method: "delete",
    url: CRUD_INTEGRATION,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    tagDetailData: [],
    details: [],
    selectedTaggedData: {},
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "integration",
  apiConfig,
  customReducers,
);
const integrationSlice = slice;
// Export the slice's reducer
export default integrationSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addIntegration,
  getIntegrationByCategory,
  getIntegrationDetails,
  updateIntegration,
  deleteIntegration,
} = thunks;

// Destructure and export actions directly from actionsExports
export const {
  rowSelect,
} = actions;
